import React, {useEffect, useState} from "react";
import {Panel} from 'primereact/panel';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Divider} from 'primereact/divider';
import GeneralUtils from "../../../utils/GeneralUtils";
import {ConfirmDialog} from "primereact/confirmdialog";

const defaultData = {
    objectives: [],
    prerequisites: [],
    targetAudiences: []
}
const Goals = (props) => {
    const {course, setCourse} = props;
    const [data, setData] = useState(course);
    const [objectivesPH, setObjectivesPH] = useState([
        ('---Örnek: Proje yöneticilerinin rollerini ve sorumluluklarını tanımlayın---'),
        ('---Örnek: Proje zaman çizelgelerini ve bütçeleri hesaplayın---'),
        ('---Örnek: Proje risklerini tanımlayın ve yönetin---'),
        ('---Örnek: Konsept aşamasından tamamlanana kadar bir projeyi yönetmek için bir örnek olay çalışması tamamlayın---')
    ]);

    const [prerequisitesPH, setPrerequisitesPH] = useState([
        ('---Örnek: Programlama deneyimi gerekmez. Bilmeniz gereken her şeyi öğreneceksiniz---')
    ]);

    const [targetAudiencesPH, setTargetAudiencesPH] = useState([
        ('---Örnek: Veri bilimine meraklı, başlangıç düzeyindeki Python geliştiricileri---')
    ]);

    const moreObjective = '---Öğrenciler, kursunuzda ne öğrenecek?---';
    const morePrerequisite = '---Kursunuzu almak için gereksinimler veya ön koşullar nelerdir?---';
    const moreTargetAudience = '---Bu kurs kime yönelik?---';


    useEffect(() => {
        setCourse(data);
        // if (!GeneralUtils.isNullOrEmpty(data)) {
        //     if (!GeneralUtils.isNullOrEmpty(data.objectives) && data.objectives.length > objectivesPH.length) {
        //         for (let i = 0; i < data.objectives.length - objectivesPH.length; i++) {
        //             setObjectivesPH([...objectivesPH, moreObjective]);
        //         }
        //     }
        //     if (!GeneralUtils.isNullOrEmpty(data.prerequisites) && data.prerequisites.length > prerequisitesPH.length) {
        //         for (let i = 0; i < data.prerequisites.length - prerequisitesPH.length; i++) {
        //             setPrerequisitesPH([...prerequisitesPH, morePrerequisite]);
        //         }
        //     }
        //     if (!GeneralUtils.isNullOrEmpty(data.targetAudiences) && data.targetAudiences.length > targetAudiencesPH.length) {
        //         for (let i = 0; i < data.targetAudiences.length - data.targetAudiences.length; i++) {
        //             setTargetAudiencesPH([...targetAudiencesPH, moreTargetAudience]);
        //         }
        //     }
        // }
    }, [data]);

    const handleChange = (e, index) => {
        const {name, value} = e.target;
        const list = [...data[name]];
        list[index] = value;
        setData((prevData) => ({...prevData, [name]: list}));
        // setCourse({...data, [name]: list});
    };

    const handleDelete = (name, index) => {
        const list = [...data[name]];
        list.splice(index, 1);
        setData((prevData) => ({...prevData, [name]: list}));
        setObjectivesPH(objectivesPH.filter((_, i) => i !== index));
    }

    return (
        <Panel header="Hedef Örenciler">
            <Divider align="left"><b>Öğrenciler, kursunuzda ne öğrenecek?</b></Divider>
            <div className="flex flex-column gap-2">
                {/*<label>Öğrenciler, kursunuzda ne öğrenecek?</label>*/}
                <small>Öğrencilerin, kursunuzu tamamladıktan sonra başarabilecekleri en az 4 öğrenim hedefi veya sonuç
                    girmelisiniz.</small>

                {objectivesPH?.map((objective, index) => (
                    // <div className="flex flex-row gap-2">
                    <InputText key={`objective-${index}`} name="objectives" value={data.objectives[index]} type="text"
                               className="inputtext p-inputtext-sm"
                               placeholder={objective} onChange={(e) => handleChange(e, index)}/>
                        // <Button icon="pi pi-fw pi-trash" outlined severity="danger" onClick={(e) => handleDelete("objectives", index)}/>
                    // </div>
            ))}
        </div>
    <Button icon='pi pi-plus' label="Yanıtınıza daha fazla bilgi ekleyin"
            onClick={() => setObjectivesPH([...objectivesPH, moreObjective])}
            className="p-button-text p-button-sm"
            disabled={data.objectives.filter(objective => !GeneralUtils.isNullOrEmpty(objective)).length < objectivesPH.length}/>


    <Divider align="left"><b>Kursunuzu almak için gereksinimler veya ön koşullar nelerdir?</b></Divider>
    <div className="flex flex-column gap-2">
        {/*<label>Kursunuzu almak için gereksinimler veya ön koşullar nelerdir?</label>*/}
        <small>Öğrencilerin kursunuzu almadan önce sahip olması gereken yetkinlikleri, deneyimleri, araçları
            veya ekipmanları listeleyin.</small>
        <small>Hiçbir gereksinim yoksa bunu, yeni başlayanlar için bariyeri düşürmeye yönelik bir fırsat olarak
            kullanın.</small>

        {prerequisitesPH?.map((prerequisite, index) => (
            <InputText key={`prerequisite-${index}`} name="prerequisites" value={data.prerequisites[index]} type="text"
                       className="inputtext p-inputtext-sm"
                       placeholder={prerequisite} onChange={(e) => handleChange(e, index)}/>
        ))}

    </div>
    <Button icon='pi pi-plus' label="Yanıtınıza daha fazla bilgi ekleyin"
            onClick={() => setPrerequisitesPH([...prerequisitesPH, morePrerequisite])}
            className="p-button-text p-button-sm"
            disabled={data.prerequisites.filter(prerequisite => !GeneralUtils.isNullOrEmpty(prerequisite)).length < prerequisitesPH.length}/>


    <Divider align="left"><b>Bu kurs kime yönelik?</b></Divider>
    <div className="flex flex-column gap-2">
        {/*<label>Bu kurs kime yönelik?</label>*/}
        <small>Kurs içeriğinizi değerli bulacak hedef öğrenciler için net bir açıklama girin.</small>
        <small>Bu, doğru öğrencileri kursunuza çekmenize yardımcı olur.</small>

        {targetAudiencesPH?.map((targetAudience, index) => (
            <InputText key={`targetAudience-${index}`} name="targetAudiences" value={data.targetAudiences[index]}
                       type="text"
                       className="inputtext p-inputtext-sm"
                       placeholder={targetAudience} onChange={(e) => handleChange(e, index)}/>
        ))}
    </div>
    <Button icon='pi pi-plus' label="Yanıtınıza daha fazla bilgi ekleyin"
            onClick={() => setTargetAudiencesPH([...targetAudiencesPH, moreTargetAudience])}
            className="p-button-text p-button-sm"
            disabled={data.targetAudiences.filter(targetAudience => !GeneralUtils.isNullOrEmpty(targetAudience)).length < targetAudiencesPH.length}/>

</Panel>
)
};

export default Goals;
